export default __webpack_public_path__ + "static/media/package-default-image.3d4b1fcf.png";